import { Component, HostBinding, input, output } from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';

@Component({
  selector: 'spx-expandable',
  templateUrl: './expandable.component.html',
  styleUrl: './expandable.component.scss',
  imports: [MatExpansionPanel, MatExpansionPanelHeader],
})
export class ExpandableComponent {
  public isExpanded = input<boolean>(false);
  public disabled = input<boolean>(false);
  public hideToggle = input<boolean>(false);
  public opened = output<void>();
  public closed = output<void>();
  private _expanded = false;

  @HostBinding('class.expanded')
  get expandedClass() {
    return this._expanded;
  }

  onOpened() {
    this._expanded = true;
    this.opened.emit();
  }

  onClosed() {
    this._expanded = false;
    this.closed.emit();
  }
}
